export default __webpack_public_path__ + "static/media/binance.4f75b722.png";